import { useEffect, useRef, useState } from "react";
import { Button } from "@/components/ui/button";
import { ChevronDown, ChevronUp } from "lucide-react";

interface ShowMoreProps {
  lines?: number;
  showButton?: boolean;
  children: React.ReactNode;
}

export const ShowMore = ({
  lines = 5,
  showButton = true,
  children,
}: ShowMoreProps) => {
  const [showMore, setShowMore] = useState(false);
  const [isOverflowing, setIsOverflowing] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = contentRef.current;
    if (!el) return;

    const checkOverflow = () => {
      setIsOverflowing(el.scrollHeight > el.clientHeight + 1);
    };

    checkOverflow();

    const observer = new ResizeObserver(checkOverflow);
    observer.observe(el);
    return () => observer.disconnect();
  }, [children, lines]);

  return (
    <div>
      <div
        ref={contentRef}
        className={showMore ? "" : "overflow-hidden"}
        style={
          showMore
            ? undefined
            : {
                display: "-webkit-box",
                WebkitBoxOrient: "vertical",
                WebkitLineClamp: lines,
              }
        }
      >
        {children}
      </div>
      {showButton && (isOverflowing || showMore) && (
        <Button
          variant="ghost"
          size="lg"
          className="mt-4 px-0 h-auto py-1"
          onClick={() => setShowMore(!showMore)}
        >
          {showMore ? "Show Less" : "Show More"}
          {showMore ? <ChevronUp /> : <ChevronDown />}
        </Button>
      )}
    </div>
  );
};
